import requester from '@/utils/request'

export default {
  postUpdate: (data: any) => requester.post('/blog/v1/save', data, { headers: { isSeller: true } }),
  postRemove: (id: any) =>
    requester.delete('/blog/v1/delete', { id }, { headers: { isSeller: true } }),
  changeTop: (postId: any, operateType: any) =>
    requester.post(
      '/blog/v1/top',
      {
        postId,
        operateType,
      },
      { headers: { isSeller: true } },
    ),
  exchangeRate: (data: any) =>
    requester.post('/wallet/v1/exchange-rate', data, { headers: { isSeller: true } }),
  queryDeployStatus: (data: any) =>
    requester.post('/nft/v1/album/queryDeployStatus', data, { headers: { isSeller: true } }),
  // post 创建 & 编辑 new
  postCreate: (data: any) => requester.post('/blog/v2/save', data, { headers: { isSeller: true } }),
  // post 查询草稿箱
  queryDraft: () => requester.get('/blog/v1/query/draft', {}, { headers: { isSeller: true } }),
  // 根据日期分组查询post信息(创作者使用)
  statisticByDate: (data: any) =>
    requester.post('/blog/v1/statistic/by-date', data, { headers: { isSeller: true } }),
  // 新增标签
  addPostLabel: (data: any) => requester.post('/blog/label/v1/add', data),
  // 删除标签
  removePostLabel: (data: any) => requester.post('/blog/label/v1/remove', data),
  // 修改标签
  updatePostLabel: (data: any) => requester.post('/blog/label/v1/update', data),
  // 标签列表
  getLabelList: (data: any) => requester.post('/blog/label/v1/list', data),
  // post和标签绑定
  bindPostLabel: (data: any) => requester.post('/blog-label-rel/v1/add', data),
  // post和标签解除绑定
  unbindPostLabel: (data: any) => requester.post('/blog-label-rel/v1/remove', data),
  // post点赞列表
  queryPostLikeUsers: (data: any) => requester.post('/post/favorite/v1/user/list', data),
  // 增加用户聊天关系
  addUserChatRelation: (data: any) =>
    requester.post('/chat-msg/v1/relation/add/by-post-favorite', data),
}
